import { render, staticRenderFns } from "./EmailDocumentModal.vue?vue&type=template&id=d455a08e"
import script from "./EmailDocumentModal.vue?vue&type=script&lang=js"
export * from "./EmailDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./EmailDocumentModal.vue?vue&type=style&index=0&id=d455a08e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports